import React from 'react';
import {PropTypes} from 'prop-types';
import {NormalizeClassNameString, ToString, PrepareError} from '../shared/utils';
import './errorsblock.scss';

class ErrorsBlockComponent extends React.Component {

	shouldComponentUpdate(nextProps) {
        const props = this.props;
        const result = 
            (nextProps.unstyled != props.unstyled) || 
			(nextProps.className != props.className) ||
			(nextProps.errors != props.errors) || 
			(nextProps.excludedErrors != props.excludedErrors);
            
        return result;
	}

	render() {
		const {errors, unstyled, className, excludedErrors} = this.props;
		const listClass = unstyled ? 'list-unstyled shift-left mb-0' : 'shift-left';
		const _errors = ErrorsBlockComponent.filterErrors(errors, excludedErrors);
		const items = Object.keys(_errors)
			// .map(k => <li key={k} dangerouslySetInnerHTML={{__html: ToString(_errors[k])}}></li>);
			.map(k => <li key={k}>{ToString(_errors[k])}</li>);
		
		if (items.length > 0) {
			return (
				<div className={NormalizeClassNameString('errors-block ' + ToString(className))}>
					<ul className={listClass}>
						{items}
					</ul>
				</div>
			);
		}

		return null;
	}
}
ErrorsBlockComponent.propTypes = {
	unstyled: PropTypes.bool,
	errors: PropTypes.oneOfType([PropTypes.object, PropTypes.array, PropTypes.string]),
	className: PropTypes.string,
	excludedErrors: PropTypes.string, //space separated strings
}
ErrorsBlockComponent.defaultProps = {
	unstyled: false,
	errors: null,
	className: 'text-danger'
}
ErrorsBlockComponent.filterErrors = (errors, excludedErrors) => {
	const _errors = PrepareError(errors);
	let _excludedErrors = (typeof excludedErrors === 'string')
		? excludedErrors.trim().split(' ')
		: [];
	
	_excludedErrors = _excludedErrors.concat(['_isCancelled', '_isNetworkError']);

	const result = {};
	Object.keys(_errors || {})
		//.filter(k => typeof _errors[k] !== 'boolean')
		.filter(k => Boolean(ToString(_errors[k])) && !_excludedErrors.some(p => p == k))
		.forEach(k => result[k] = _errors[k]);
	
	return result;
}

export {ErrorsBlockComponent};